import URI from 'urijs'

import Termly from 'termly-namespace'


const website = () => {
  const apiBase = Termly.apiBase

  if ( !apiBase ) {
    throw new Error('URL.website() called before the API base was initialized in state')
  }

  const websiteUUID = Termly.websiteUUID

  if ( !websiteUUID ) {
    throw new Error('URL.website() called before the website UUID was initialized in state')
  }

  return `${ apiBase }/api/v1/snippets/websites/${ websiteUUID }`
}

const statistic = () => `${ website() }/statistics`

const getCountry = () => {
  return `${ Termly.apiBase }/api/v1/ip`
}

const getCookies = ({ locale, region }) => {
  const baseURL = new URI(`${ website() }/cookies`)
    .query({
      lang: locale,
    })

  if ( Termly.tcf && region === 'eu' ) {
    baseURL.addQuery('include_tcf_cookies', 'false')
  }

  return baseURL.toString()
}

const saveCookieConsent = () => {
  const origin = Termly.consentOrigin || process.env.DEFAULT_CONSENT_ORIGIN

  return `${ origin }/v1/websites/${ Termly.websiteUUID }/cookie-consent`
}

const docLink = (name, uuid) => {
  if ( !name ) {
    return ''
  }

  return `${ Termly.apiBase }/policy-viewer/policy.html?policyUUID=${ uuid }`
}

const fullTcfGVL = () => {
  return `${ Termly.apiBase }/resource-blocker/support/complete-tcf-gvl`
}

const tcfGVL = ({ lang, websiteUUID }) => {
  return `${ Termly.apiBase }/resource-blocker/support/${ websiteUUID }/tcf-gvl?lang=${ lang }`
}

const gacmVendors = ({ websiteUUID }) => {
  return `${ Termly.apiBase }/resource-blocker/support/${ websiteUUID }/gacm-vendors`
}

export default {
  docLink,
  fullTcfGVL,
  gacmVendors,
  getCookies,
  getCountry,
  saveCookieConsent,
  statistic,
  tcfGVL,
  website,
}
